import { useState } from 'react'
import useInitialDamageTypeFields from '../vehicleDamages/useInitialDamageTypeFields'

const initializeDamageTypes = (
  key: any,
  damageTypeFields: { [x: string]: any }
) => {
  const damageTypeOptions = Object.keys(damageTypeFields).map((key) => {
    return [damageTypeFields[key], key]
  })

  const initializedDamageTypes: { [key: string]: boolean } = {}

  Object.keys(damageTypeFields).forEach((key) => {
    initializedDamageTypes[key] = false
  })

  return { damageTypeOptions, initializedDamageTypes }
}

const useDamageTypes = (tabValue: any) => {
  const damageTypeFields = useInitialDamageTypeFields(tabValue)
  const { damageTypeOptions, initializedDamageTypes } = initializeDamageTypes(
    tabValue,
    damageTypeFields
  )

  const [damageTypes, setDamageTypes] = useState(initializedDamageTypes)

  return { damageTypeOptions, damageTypes, setDamageTypes }
}

export default useDamageTypes
